import script from "./OverlayLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./OverlayLoader.vue?vue&type=script&lang=ts&setup=true"

import "./OverlayLoader.vue?vue&type=style&index=0&id=b426939a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b426939a"]])

export default __exports__